import { Link } from 'react-router-dom';

export function NotFoundPage() {
    return (
        <>
            <section className="page-hero">
                <div className="content-wrapper py-4">
                    <h1 className="display-6 fw-semibold mb-0">404 Not Found</h1>
                </div>
            </section>

            <div className="content-wrapper py-4">
                <div className="row g-4 mb-4">
                    <div className="col-12">
                        <p>The route you were trying to use doesn't exist. Either I'm dumb and left an old reference in the front end, or you did something weird and tried to go somewhere that doesn't exist.</p>
                    </div>
                </div>
            </div>
        </>
    );
}
